import DataQuery from "data/DataQuery";
import { Contracting_Configuration, Contracting_Get } from "data/endpoints";
import { useQuery } from "data/hooks/useQuery";
import { getRouteParams } from "features/shared/helpers/routeParams";
import React from "react";
import { ContractingDTO } from "features/contracting/dtos/ContractingDTO";
import { ContractingConfigurationDTO } from "features/contracting/dtos/ContractingConfigurationDTO";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import { isEmpty } from "features/shared/helpers/objects";
import { loadModule } from "features/shared/helpers/modules";
import ContractingStepConfiguration from "features/contracting/models/ContractingStepConfiguration";
import ContractingSummary from "features/contracting/components/overview/summary/ContractingSummary";

const contractingSteps = loadModule<ContractingStepConfiguration[]>(
  "contracting/contractingSteps.json"
);

type Props = {
  contractingId: string;
};

const ContractingDetailSection = ({ contractingId }: Props) => {
  // fetch data
  // contracting
  const contractingQuery: DataQuery = {
    url: Contracting_Get,
    routeParams: getRouteParams("contractingId", contractingId),
  };
  const { data: contracting, loadStatus: contractingLoadStatus } =
    useQuery<ContractingDTO>(contractingQuery, {
      steps: {},
    });
  // configuration
  const configQuery: DataQuery = {
    url: Contracting_Configuration,
  };
  const { data: configuration, loadStatus: configLoadStatus } =
    useQuery<ContractingConfigurationDTO>(configQuery, {});

  // helpers
  const isEmtpyData = () => {
    if (isEmpty(configuration) || Object.keys(contracting.steps).length === 0) {
      return true;
    }

    return false;
  }

  // render
  return (
    <NoContentWrapper
      data={contracting}
      loadStatus={[contractingLoadStatus, configLoadStatus]}
      isEmpty={isEmtpyData}
    >
      <div className="mt-n4">
        <ContractingSummary
          contracting={contracting}
          steps={contractingSteps}
          configuration={configuration}
          disableEdit
          skipOverview={false}
        />
      </div>
    </NoContentWrapper>
  );
};

export default ContractingDetailSection;
